



















































import { Component, Vue } from 'vue-property-decorator';
import { observeUser } from '@/firebaseApp';
import * as firebase from 'firebase';
import Teacher from '@/services/Teacher';
import { Teacher as ITeacher } from '@/models/Teachers';
import AdminMenu from '@/components/admin/AdminMenu.vue';
import ModalContainer from '@/components/modals/ModalContainer.vue';
import AdminSchool from '@/components/admin/AdminSchool.vue';
import { ISchool } from '@/models/School';

type schoolDict = { [key: string]: ISchool };

@Component({
  components: { AdminSchool, ModalContainer, AdminMenu },
})
export default class Admin extends Vue {
  public user: firebase.User | null = null;
  public teachers: ITeacher[] = [];
  public isOpen = false;

  mounted() {
    Teacher.observeAllTeachers(teachers => {
      this.teachers = teachers;
    });

    observeUser(user => (this.user = user));
  }

  createTeacher() {
    this.$emit('create-teacher');
  }

  get schools() {
    if (!this.teachers) {
      return null;
    }

    return this.teachers.reduce((all, teacher) => {
      const key = this.cleanSchoolName(teacher.school);
      const school = all[key];

      if (!school) {
        all[key] = {
          name: teacher.school,
          teachers: [],
        };
      }

      all[key].teachers.push(teacher);
      return all;
    }, {} as schoolDict);
  }

  get schoolIds() {
    const ids = this.schools ? Object.keys(this.schools) : [];
    ids.sort((a: string, b: string) => (a > b ? 1 : b > a ? -1 : 0));
    return ids;
  }

  cleanSchoolName(name: string) {
    if (!name) {
      return 'zzzz';
    }

    return name
      .trim()
      .replace(/\s/g, '-')
      .toLowerCase();
  }

  toggleAllRows() {
    this.isOpen = !this.isOpen;
  }
}
